import { render } from "./AllSegmentGroupsFrequency.vue?vue&type=template&id=44174e1a"
import script from "./AllSegmentGroupsFrequency.vue?vue&type=script&lang=js"
export * from "./AllSegmentGroupsFrequency.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__